import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';

import {type IAttributeTemplate} from '../schema';

export type MetadataDatasetLookup = {
	label: IAttributeTemplate['name'];
	value: string;
};

/**
 * `metadataDatasetLookup` request params
 * (what is used to send to server)
 */
export type MetadataDatasetLookupRequestOptions = {
	name: IAttributeTemplate['name'];
	value: string;
};

/**
 * `metadataDatasetLookup` request
 * (what gets sent to the server)
 */
export type MetadataDatasetLookupRequest = [
	MetadataDatasetLookupRequestOptions['name'],
	MetadataDatasetLookupRequestOptions['value'],
];

/**
 * `metadataDatasetLookup` response
 * (what comes back from the server)
 */
export type MetadataDatasetLookupResponse =
	SuccessResponse<MetadataDatasetLookupResult>;

/**
 * `metadataDatasetLookup` result
 * (what is utilized from the server response)
 */
export type MetadataDatasetLookupResult = MetadataDatasetLookup[];

export const metadataDatasetLookupEndpoint = 'metadataDatasetLookup';

/**
 * Metadata dataset lookup
 */
export const metadataDatasetLookup = async ({
	name,
	value,
}: MetadataDatasetLookupRequestOptions) => {
	const client = NetxQueryClient();

	const requestParams: MetadataDatasetLookupRequest = [name, value];

	return client
		.post<MetadataDatasetLookupResponse>(
			metadataDatasetLookupEndpoint,
			requestParams,
		)
		.then((response) => response.data.result);
};

export default metadataDatasetLookup;
